import { faCheckCircle } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import I18n from '@src/i18n';
import styled from '@src/styled-components';
import { Button, Col, Modal, Progress, Row } from 'antd';
import React from 'react';

const videoProcess = require('@src/images/process.mp4')
const videoQrCode = require('@src/images/qrcode.mp4')
const videoDashboard = require('@src/images/dashboard.mp4')

interface PropsType {
  visibleOnboarding: boolean;
  toggleOnboardingModal: Function;
}

interface StateType {
  visibleVideoModal: boolean;
  titleVideo: string;
  percentageWatched: number
}

export default class OnboardingVideos extends React.Component<PropsType, StateType> {
  constructor(props: PropsType) {
    super(props)
    this.state = {
      visibleVideoModal: false,
      titleVideo: '',
      percentageWatched: 0
    }
  }

  componentDidMount = async () => {
    const initPercentageWached = localStorage.getItem('percentageWatched')
    this.setState({ percentageWatched: Number(initPercentageWached) })
  }

  toogleVideoModal = async (typeVideo: string) => {
    this.setState({ visibleVideoModal: !this.state.visibleVideoModal })
    if (typeVideo === 'process') {
      this.setState({
        titleVideo: I18n.l('titles.liteProcesses'),
      })
      if (this.state.percentageWatched === 0) {
        this.setState({ percentageWatched: 33 })
      }
    }
    if (typeVideo === 'qrcode') {
      this.setState({
        titleVideo: I18n.l('titles.targets'),
      })
      if (this.state.percentageWatched === 33) {
        this.setState({ percentageWatched: 66 })
      }
    }
    if (typeVideo === 'dashboard') {
      this.setState({
        titleVideo: I18n.l('titles.dashboard'),
      })
      if (this.state.percentageWatched === 66) {
        this.setState({ percentageWatched: 100 })
      }
    }
    localStorage.setItem('percentageWatched', JSON.stringify(this.state.percentageWatched))
  }


  renderVideo(typeVideo: string) {
    if (this.state.visibleVideoModal) {
      switch (typeVideo) {
        case I18n.l('titles.liteProcesses'): {
          return (
            <video width='100%' controls>
              <source src={videoProcess} type="video/mp4" />
            </video>
          );
        }
        case I18n.l('titles.targets'):
          return (
            <video width='100%' controls>
              <source src={videoQrCode} type="video/mp4" />
            </video>
          );
        case I18n.l('titles.dashboard'):
          return (
            <video width='100%' controls>
              <source src={videoDashboard} type="video/mp4" />
            </video>
          );
        default:
          return;
      }
    }
    else return;
  }

  renderCountWatched() {
    if (this.state.percentageWatched === 33) {
      return '1/3'
    }
    if (this.state.percentageWatched === 66) {
      return '2/3'
    }
    if (this.state.percentageWatched === 100) {
      return '3/3'
    }
    else return '0/3'
  }

  render() {
    return (
      <>
        <Modal
          visible={this.props.visibleOnboarding}
          footer={false}
          width={'80vw'}
          closable={false}
          destroyOnClose={true}
        >
          <ModalContent>
            <h1 className='title-style'>{I18n.l('onboardingVideo.firstSteps')}</h1>
            <Row>
              <Col span={2} >
                <span className='count-style'>{this.renderCountWatched()} </span>
              </Col>
              <Col span={22} >
                <Progress showInfo={false} className='progress-bar' percent={this.state.percentageWatched} />
              </Col>
            </Row>
            <Row style={{ paddingTop: '2rem' }}>
              <Col span={24}>
                <div className={'box-onboarding-enabled'} onClick={() => this.toogleVideoModal('process')}>
                  <div className='title-box-onboarding'>{I18n.l('titles.liteProcesses')}</div>
                  <span className='description-box-onboarding'>{I18n.l('onboardingVideo.descriptionProcess')}</span>
                  {this.state.percentageWatched >= 33 &&
                    <FontAwesomeIcon className='icon-style' size='3x' icon={faCheckCircle} />
                  }
                </div>
                <div className={this.state.percentageWatched >= 33 ? 'box-onboarding-enabled' : 'box-onboarding-disabled'} onClick={this.state.percentageWatched >= 33 ? () => this.toogleVideoModal('qrcode') : console.log}>
                  <div className='title-box-onboarding'>{I18n.l('titles.targets')}</div>
                  <span className='description-box-onboarding'>{I18n.l('onboardingVideo.descriptionQrCode')}</span>
                  {this.state.percentageWatched >= 66 &&
                    <FontAwesomeIcon className='icon-style' size='3x' icon={faCheckCircle} />
                  }
                </div>
                <div className={this.state.percentageWatched >= 66 ? 'box-onboarding-enabled' : 'box-onboarding-disabled'} onClick={this.state.percentageWatched >= 66 ? () => this.toogleVideoModal('dashboard') : console.log}>
                  <div className='title-box-onboarding'>{I18n.l('titles.dashboard')}</div>
                  <span className='description-box-onboarding'>{I18n.l('onboardingVideo.descriptionDashboard')}</span>
                  {this.state.percentageWatched === 100 &&
                    <FontAwesomeIcon className='icon-style' size='3x' icon={faCheckCircle} />
                  }
                </div>
              </Col>
            </Row>
            <div className='buttons-style'>
              <Button onClick={this.props.toggleOnboardingModal()} ghost style={{ fontWeight: 'bold' }} type="primary">{I18n.l('common.exit')}</Button>
            </div>
          </ModalContent>
        </Modal>

        {/* MODAL VIDEO */}

        <Modal
          visible={this.state.visibleVideoModal}
          footer={false}
          width={'60vw'}
          closable={false}
        >
          <ModalContent>
            <h1 className='title-style'>{this.state.titleVideo}</h1>
            <div className='box-video' >
              {this.renderVideo(this.state.titleVideo)}
            </div>
            <div className='buttons-style'>
              <Button onClick={() => this.setState({ visibleVideoModal: false })} type="primary">Prosseguir</Button>
            </div>
          </ModalContent>
        </Modal>
      </>
    );
  }
}


const ModalContent = styled.div`
  padding-left: 1vw;
  font-family: Montserrat;
	font-style: normal;
	.title-style {
		font-weight: 800;
		font-size: 2vw;
		color: #335D7C;
	}
  .count-style {
    font-weight: 800;
		font-size: 2vw;
    color: #CDD3E7;
  }
  .progress-bar {
    line-height: 2.8vw;
  }
  .circle-style {
  height: 3vw;
  width: 3vw;
  background-color: #F3F6FC;
  border: 1px solid #6A8CA5;
  border-radius: 50%;
  display: inline-block;
}
.border-timeline {
  border-left: 3px solid #C6D3DD ;
  height: 50px;
}
.box-onboarding-enabled {
  width: 100%;
  background: #F3F6FC;
  border-radius: 5px;
  margin-bottom: 2rem;
  /* border: 1px solid #A8B1D2; */
  padding: 25px 25px 25px 40px;
  box-shadow: 2px 4px 4px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  .title-box-onboarding {
    font-weight: 600;
    font-size: 22px;
    color: #6A8CA5;
  }
  .description-box-onboarding {
    font-weight: 600;
    font-size: 14px;
    color: #335D7C;
  }
}
.box-onboarding-disabled {
  width: 100%;
  background: #F3F6FC;
  border-radius: 5px;
  margin-bottom: 2rem;
  border: 1px solid #A8B1D2;
  padding: 25px 25px 25px 40px;
  .title-box-onboarding {
    font-weight: 600;
    font-size: 22px;
    color: #B6B6B6;
  }
  .description-box-onboarding {
    font-weight: 600;
    font-size: 14px;
    color: #68869C;
  }
}
.box-video {
  width: 50vw;
  background: #F3F6FC;
  border-radius: 5px;
  margin-bottom: 2rem;
  border: 1px solid #A8B1D2;
  padding: 25px;
}

.buttons-style {
	text-align: center;
	display: block;
	margin-left: auto;
	margin-right: auto;
	width: 50%;
}

.icon-style {
  margin-top: -22px;
  right: 45px; 
  color: #52c41a;
  position: absolute;
}
`;

